/* global $ */
window.blogController = function blogController () {
  const controls = {
    btnLoadMore: '.btn-load-more',
    blogItemsContainer: '.sec-bloglist--items',
    emptyState: '.sec-bloglist--empty',
    errorState: '.sec-bloglist--error',
    dropdown: '.ddl-blogcategory',
    dropdownToggle: '.ddl-blogcategory .dropdown-toggle',
    categoryFilter: '.ddl-blogcategory .dropdown-toggle #filterText',
    desktopLinks: '.lnk-blogcategories a'
  };

  const model = {
    defaults: {
      desktopPageSize: 9,
      mobilePageSize: 4
    },
    paging: {
      size: 0,
      number: 0,
      totalItems: 0
    },
    filter: {
      category: 'all',
      text: 'All'
    },
    isInitialLoad: true,
    requestId: 0
  };

  let getTimeout = null;

  function isMobile () {
    return document.body.getBoundingClientRect().width < 900;
  }

  function bindEvents () {
    $(controls.btnLoadMore).off('click').on('click', loadMore);
    $(controls.dropdownToggle).off('click').on('click', toggleDropdown);
    $(document).off('click.blogCategory').on('click.blogCategory', function (e) {
      if (!$(e.target).closest(controls.dropdown).length) {
        closeDropdown();
      }
    });

    model.paging.size = isMobile() ? model.defaults.mobilePageSize : model.defaults.desktopPageSize;

    const urlParams = new URLSearchParams(window.location.search);
    let categoryClass = urlParams.get('category') || 'all';
    const safeCategoryClass = (categoryClass || 'all').replace(/[^a-z0-9-]/gi, '');
    let selectedLink = $(controls.desktopLinks).filter('.' + safeCategoryClass);
    if (!selectedLink.length) {
      selectedLink = $(controls.desktopLinks).filter('.all');
      categoryClass = 'all';
    }

    $(controls.desktopLinks).removeClass('active-link');
    selectedLink.addClass('active-link');
    model.filter.category = selectedLink.attr('data-value') || 'all';
    model.filter.text = selectedLink.first().text().trim() || 'All';
    $(controls.categoryFilter).text(model.filter.text);
    syncDropdownSelection();

    if (isMobile()) {
      $(controls.dropdown + ' .dropdown-item').off('click').on('click', onDropdownItemClick);
    }

    getBlogs(model.filter.category, model.paging.size, model.paging.number, false);
  }

  function toggleDropdown (e) {
    e.preventDefault();
    e.stopPropagation();
    const dropdown = $(controls.dropdown);
    const isOpen = dropdown.toggleClass('is-open').hasClass('is-open');
    $(controls.dropdownToggle).attr('aria-expanded', isOpen ? 'true' : 'false');
  }

  function closeDropdown () {
    $(controls.dropdown).removeClass('is-open');
    $(controls.dropdownToggle).attr('aria-expanded', 'false');
  }

  function syncDropdownSelection () {
    const selectedValues = model.filter.category === 'all' || !model.filter.category
      ? ['all']
      : model.filter.category.split(',').filter(Boolean);

    $(controls.dropdown + ' .dropdown-item').each(function () {
      const value = $(this).attr('data-value');
      const selected = selectedValues.indexOf(value) !== -1;
      $(this).toggleClass('selected', selected);
      $(this).find('.checkmark').toggleClass('is-checked', selected);
    });
  }

  function onDropdownItemClick (e) {
    e.preventDefault();
    e.stopPropagation();
    clearTimeout(getTimeout);

    const item = $(this);
    const value = item.attr('data-value');
    const text = item.attr('data-text') || item.text().trim();

    if (item.hasClass('selected')) {
      item.removeClass('selected');
      item.find('.checkmark').removeClass('is-checked');
      model.filter.category = model.filter.category.split(',').filter(function (x) { return x && x !== value; }).join(',');
      model.filter.text = model.filter.text.split(',').filter(function (x) { return x && x !== text && x !== 'All'; }).join(',');
    } else {
      if (model.isInitialLoad) {
        model.isInitialLoad = false;
        model.filter.category = '';
        model.filter.text = '';
      }

      if (value === 'all') {
        model.filter.category = 'all';
        model.filter.text = 'All';
        $(controls.dropdown + ' .dropdown-item.selected').removeClass('selected').find('.checkmark').removeClass('is-checked');
      } else {
        $(controls.dropdown + " .dropdown-item[data-value='all']").removeClass('selected').find('.checkmark').removeClass('is-checked');
        if (model.filter.category === 'all') {
          model.filter.category = '';
          model.filter.text = '';
        }

        const categories = model.filter.category ? model.filter.category.split(',') : [];
        categories.push(value);
        model.filter.category = categories.filter(Boolean).join(',');

        const labels = model.filter.text && model.filter.text !== 'All' ? model.filter.text.split(',') : [];
        labels.push(text);
        model.filter.text = labels.filter(Boolean).join(',');
      }

      item.addClass('selected');
      item.find('.checkmark').addClass('is-checked');
    }

    if (!model.filter.category) {
      model.filter.category = 'all';
      model.filter.text = 'All';
      $(controls.dropdown + " .dropdown-item[data-value='all']").addClass('selected').find('.checkmark').addClass('is-checked');
    }

    if (!model.filter.text || model.filter.category === 'all') {
      $(controls.categoryFilter).text('All');
    } else {
      const selectedLabels = model.filter.text.split(',').filter(Boolean);
      $(controls.categoryFilter).text(selectedLabels.length === 1 ? selectedLabels[0] : selectedLabels.length + ' items selected');
    }

    getTimeout = setTimeout(function () {
      resetAndLoad();
    }, 400);
  }

  function resetAndLoad () {
    model.paging.number = 0;
    $(controls.blogItemsContainer).empty();
    getBlogs(model.filter.category, model.paging.size, model.paging.number, false);
  }

  function loadMore () {
    model.paging.number += 1;
    getBlogs(model.filter.category, model.paging.size, model.paging.number, true);
  }

  function setHidden ($el, hidden) {
    if (hidden) {
      $el.attr('hidden', 'hidden');
    } else {
      $el.removeAttr('hidden');
    }
  }

  async function getBlogs (category, pageSize, pageNumber, append) {
    const requestId = ++model.requestId;
    setHidden($(controls.errorState), true);
    if (!append) {
      setHidden($(controls.emptyState), true);
      setHidden($(controls.btnLoadMore), true);
    }

    const params = new URLSearchParams({
      category: category || 'all',
      take: String(pageSize),
      page: String(pageNumber)
    });

    try {
      const response = await fetch('/umbraco/api/blogsearch/filter?' + params.toString(), {
        method: 'GET'
      });

      if (!response.ok) {
        throw new Error('Request failed');
      }

      const blogs = await response.json();
      if (requestId !== model.requestId) {
        return;
      }

      const items = Array.isArray(blogs.data) ? blogs.data : [];
      model.paging.totalItems = Number(blogs.totalCount) || 0;

      if (!append) {
        $(controls.blogItemsContainer).empty();
      }

      items.forEach(function (data) {
        buildBlogCard(data);
      });

      const loadedCount = $(controls.blogItemsContainer).children().length;
      setHidden($(controls.emptyState), loadedCount > 0);
      setHidden($(controls.btnLoadMore), loadedCount >= model.paging.totalItems);
    } catch (error) {
      if (requestId !== model.requestId) {
        return;
      }

      if (!append) {
        $(controls.blogItemsContainer).empty();
      }
      setHidden($(controls.emptyState), true);
      setHidden($(controls.btnLoadMore), true);
      setHidden($(controls.errorState), false);
    }
  }

  function buildCategoryPills (categories) {
    const categoryWrap = $('<div>', { class: 'sec-bloglist--categories' });
    categories.forEach(function (name) {
      categoryWrap.append($('<span>', { class: 'text-uppercase', text: name }));
    });
    return categoryWrap;
  }

  function buildBlogCard (data) {
    const item = $('<div>', { class: 'sec-bloglist--item' });
    const content = $('<div>', { class: 'sec-bloglist--content' });
    const meta = $('<div>', { class: 'sec-bloglist--meta' });
    const categories = (data.category || '').split(',').map(function (value) { return value.trim(); }).filter(Boolean);

    if (data.publishDate) {
      meta.append($('<div>', { class: 'sec-bloglist--publishdate', text: data.publishDate }));
    }

    if (categories.length && !data.thumbnailImage) {
      meta.append(buildCategoryPills(categories));
    }

    if (meta.children().length) {
      content.append(meta);
    }

    const titleLink = $('<a>', { href: data.url || '#', class: 'sec-bloglist--title' });
    titleLink.append($('<div>', { class: 'h5', text: data.title || '' }));
    content.append(titleLink);

    if (data.excerpt) {
      content.append($('<div>', { class: 'sec-bloglist--description', text: data.excerpt }));
    }

    const readMore = $('<div>', { class: 'sec-bloglist--link' });
    const readMoreLink = $('<a>', { href: data.url || '#' });
    const button = $('<button>', { type: 'button', class: 'btn btn-primary-outlined' });
    button.append($('<span>', { class: 'text', text: 'Read More' }));
    button.append($('<img>', { src: '/images/long_right.svg', height: 18, width: 18, alt: '>' }));
    readMoreLink.append(button);
    readMore.append(readMoreLink);
    content.append(readMore);

    if (data.thumbnailImage) {
      const thumbnail = $('<div>', { class: 'sec-bloglist--thumbnail' });
      const thumbnailLink = $('<a>', { href: data.url || '#' });
      const thumbnailWrap = $('<div>', { class: 'rounded-corner blurred-img' });
      if (data.thumbnailPlaceholder) {
        thumbnailWrap.css('background-image', 'url("' + data.thumbnailPlaceholder + '")');
      }
      const thumbnailImg = $('<img>', {
        class: 'lazyload rounded-corner',
        alt: data.thumbnailAlt || ''
      });
      thumbnailImg.attr('data-src', data.thumbnailImage);
      thumbnailImg.attr('data-srcset', data.thumbnailImage);
      thumbnailWrap.append(thumbnailImg);
      thumbnailLink.append(thumbnailWrap);
      thumbnail.append(thumbnailLink);
      if (categories.length) {
        thumbnail.append(buildCategoryPills(categories));
      }
      item.append(thumbnail);
    }

    item.append(content);
    $(controls.blogItemsContainer).append(item);
  }

  return {
    init: function () {
      bindEvents();
    }
  };
};
